// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  mfe: "mfe"
}
  /*
  mfe: "mfe",
  keycloak: {
    realm: "SDGKeycloak",
    url: "http://finsosvil.bluesystem.it/keycloak",
    clientId: "sdg_infra_frontend",
    onLoad: "login-required",
    checkLoginIframe: false
  }
};

/*
export const environment = {
  production: false,
  mfe: "mfe",
  keycloak: {
    realm: "SDGKeycloak",
    url: "https://finsotest.bluesystem.it/keycloak",
    clientId: "sdg_infra_frontend",
    onLoad: "login-required",
    checkLoginIframe: false
  }
};
 */

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
